<template>
  <b-modal title="SGC"
      header-bg-variant= "light" 
      hide-header-close
      v-model="confirmModalVisible">
      {{ confirmMsj }}
    <div slot="modal-footer">
      <b-button size="sm" variant="primary" class="footer-button"
        @click.prevent="confirmOk">{{ confirmOkTitle }}</b-button>
      <b-button size="sm" variant="danger" class="footer-button"
        @click.prevent="confirmCancel">{{ confirmCancelTitle }}</b-button>
    </div>      
  </b-modal>  
</template>

<script>
export default {
  props: {
    confirmModalVisible: {
      type: Boolean,
      default: false
    },
    confirmMsj: {
      type: String,
      default: ''
    },
    confirmOkTitle: {
      type: String,
      default: ''
    },
    confirmCancelTitle: {
      type: String,
      default: ''
    },
  },
  methods: {
    confirmOk() {
      this.$emit('confirmOk');
    },
    confirmCancel() {
      this.$emit('confirmCancel');
    }
  }
}
</script>

<style>
</style>
